// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.message.type.filter.enums.SatelliteConversationFolderTypeV2

export enum SatelliteConversationFolderTypeV2 {
  ARCHIVED = 'ARCHIVED',
  FAVORITE = 'FAVORITE',
  INBOX = 'INBOX',
  SHOW_ALL = 'SHOW_ALL',
  SPAM = 'SPAM',
}

export const SatelliteConversationFolderTypeV2_values = [
  SatelliteConversationFolderTypeV2.ARCHIVED,
  SatelliteConversationFolderTypeV2.FAVORITE,
  SatelliteConversationFolderTypeV2.INBOX,
  SatelliteConversationFolderTypeV2.SHOW_ALL,
  SatelliteConversationFolderTypeV2.SPAM,
] as const;
